/* eslint-disable react/prop-types */
import {Box, Paper, Stack, Typography, Link, useTheme} from '@mui/material';
import {memo} from 'react';
import {Handle, Position} from 'reactflow';

import {useDispatch, useSelector} from 'react-redux';
import {
  setSelectedL1Label,
  setSelectedL2Label,
  setSelectedSubProcess,
  setSelectedProcess,
} from 'app/store/appState/appStateSlice';
import {selectAllMaps, selectAllProcesses} from 'app/store/operatingModel/operatingModelSlice';
import {useMatomo} from '@jonkoops/matomo-tracker-react';
import {useNavigate} from 'react-router';
import {Custom_Encode_URL} from 'app/types/Shared';

function ProcessNode({data}) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const processMaps = useSelector(selectAllMaps);
  const allProcesses = useSelector(selectAllProcesses);

  const naviagate = useNavigate();
  const {trackEvent} = useMatomo();

  const naviagateTo = (process, operatingModel) => {
    naviagate(`/process/${process}/${operatingModel}`);
    return Promise.resolve();
  };

  const handleClick = async () => {
    const selectedMap = processMaps.find((x) => x.id === data.diagram_link_id);
    if (selectedMap) {
      const process = allProcesses.find((p) => p.process_id === selectedMap.process_name);
      if (process) {
        trackEvent({category: 'Process', action: 'Process Node Link Selected', name: process.key});
        dispatch(setSelectedL1Label(selectedMap.l1_label));
        dispatch(setSelectedL2Label(selectedMap.l2_label));
        dispatch(setSelectedProcess(process));
        dispatch(setSelectedSubProcess(selectedMap.l1_label_order));
        await naviagateTo(Custom_Encode_URL(process.name), process.operating_models_list);
      }
    }
  };

  const handleStyle = {transform: 'rotate(0deg)', opacity: '0'};
  const description = data?.description?.length > 60 ? data.description.slice(0, 70) + '...' : data.description;

  return (
    <>
      <Box width={'250px'} height={'200px'} display='flex' justifyContent='center' alignItems='center'>
        <Paper
          variant='outlined'
          sx={{
            background: theme.palette.primary.main,
            border: `1px solid ${theme.palette.grey[600]}`,
            borderRadius: '5px',
            width: '150px',
            height: data.diagram_link ? '140px' : '120px',
            '&:hover': {
              background: theme.palette.primary.main,
              boxShadow: ' 0px 0px 10px rgba(0, 0, 0, 0.25)',
            },
          }}
          onClick={() => data.diagram_link && handleClick()}
        >
          <Stack spacing={1.5} p={'10px'} sx={{textAlign: 'center'}}>
            <Typography variant='h6' color='white'>
              {description}
            </Typography>
            {data.diagram_link && <Link variant='h6' color='#FFFFFF'>{`Go to process >`}</Link>}
          </Stack>
        </Paper>
      </Box>
      <Handle id='leftSource' style={handleStyle} type='source' position={Position.Left} />
      <Handle id='topSource' style={handleStyle} type='source' position={Position.Top} />
      <Handle id='rightSource' style={handleStyle} type='source' position={Position.Right} />
      <Handle id='bottomSource' style={handleStyle} type='source' position={Position.Bottom} />

      <Handle id='leftTarget' style={handleStyle} type='target' position={Position.Left} />
      <Handle id='topTarget' style={handleStyle} type='target' position={Position.Top} />
      <Handle id='rightTarget' style={handleStyle} type='target' position={Position.Right} />
      <Handle id='bottomTarget' style={handleStyle} type='target' position={Position.Bottom} />
    </>
  );
}

export default memo(ProcessNode);
